import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Isettingfeedback } from "../../../Pages/Setting/ISetting";

export const AddSettingSlice = createSlice({
  name: "AddSettingSlice",
  initialState: {} as IReduxState<Isettingfeedback>,
  reducers: {
    addSetting: (state, _: PayloadAction<Isettingfeedback>) => {
      state.isLoading = true;
    },
    successaddSetting: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddSetting: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddSettingResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSetting,
  failureaddSetting,
  successaddSetting,
  clearAddSettingResponse,
} = AddSettingSlice.actions;

export default AddSettingSlice.reducer;
